import { Modal } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useMainProcesses, useMilestones } from 'src/query/taskCtrl'
import Select from '../input/Select'
import { ValidateRes } from 'src/service/OrgSyncService'

export interface IChangeMilestoneProcess {
  newProcess?: number
  newMilestone?: number
  show: boolean
  oldProcess?: number
  oldMilestone?: number
  type?: 'milestone' | 'process'
}

interface MigrateProcessMilestone extends IChangeMilestoneProcess {
  projectId: number
  onClose: () => void
  onSave: (validRes?: ValidateRes) => void
}

const MigrateChangeProcessMilestone: FC<MigrateProcessMilestone> = ({
  newProcess,
  newMilestone,
  oldProcess,
  oldMilestone,
  show,
  onClose,
  onSave,
  projectId,
  type,
}) => {
  const [milestoneId, setMilestone] = useState(newMilestone)
  const [processId, setProcess] = useState(newProcess)

  const { data: mainProcess = [] } = useMainProcesses(projectId)
  const { data: milestones = [] } = useMilestones(projectId)

  useEffect(() => {
    setMilestone(newMilestone)
    setProcess(newProcess)
  }, [newProcess, newMilestone])

  const onSaveItem = () => {
    if (milestoneId === undefined && processId === undefined) {
      return
    }
    const milestone = milestones.find((d) => d.id === milestoneId)
    const responsible = mainProcess?.find((u) => u.id === processId)
    onSave({
      mile_stones: {
        [oldMilestone ?? -1]: milestone ?? null,
      },
      main_processes: {
        [oldProcess ?? -1]: responsible ?? null,
      },
    })
  }
  return (
    <Modal
      title={`Change ${type === 'milestone' ? 'Milestone' : 'Mainprocess'}`}
      open={show}
      centered
      onOk={onSaveItem}
      onCancel={onClose}
      mask={false}
      okButtonProps={{
        className: '!bg-[#1677ff] hover:scale-105',
      }}
    >
      <div className="flex flex-col py-4">
        <Select
          onChange={setMilestone}
          name={['name']}
          value={milestoneId}
          label={'Milestone*'}
          items={milestones}
          error={!milestoneId || milestoneId < 0}
          placeholder="Select discipline"
          id={'id'}
          visible={type === 'milestone'}
        />
        <div className="mt-2" />
        <Select
          onChange={setProcess}
          name={['name']}
          value={processId}
          label={'Mainprocess*'}
          items={mainProcess ?? []}
          error={!processId || processId < 0}
          placeholder={'Select Mainprocess'}
          id={'id'}
          visible={type === 'process'}
        />
      </div>
    </Modal>
  )
}

export default MigrateChangeProcessMilestone
